<template>
  <div class="confirm-calendar">
    <transition name="fade">
      <div class="confirm-calendar__mask" v-show="isShowCalendar" @click="calendarHide"></div>
    </transition>
    <div class="confirm-calendar__wrap">
      <i-input
        v-model="inputText"
        size="small"
        @on-focus="onFocusInput"
        @on-clear="onClearInput"
        placeholder
        clearable
        readonly
        icon="ios-calendar-outline"
        style="width: 220px;"
      ></i-input>
      <transition name="fade">
        <div class="confirm-calendar__content" v-show="isShowCalendar">
          <i-icon type="ios-close" size="32" class="confirm-calendar__close" @click="calendarHide" />
          <v-date-picker
            mode="range"
            :formats="formats"
            :columns="$screens({ default: 1, lg: 2 })"
            :max-date="new Date()"
            :attributes="attrs"
            v-model="selectedDate"
            is-inline
          />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
// @docs https://vcalendar.netlify.com
import VCalendar from 'v-calendar'
Vue.use(VCalendar)

import { Input, Icon } from 'view-design'
export default {
  components: {
    'i-input': Input,
    'i-icon': Icon,
  },
  props: {
    from: {
      type: String,
      default: '',
    },
    to: {
      type: String,
      default: '',
    },
    confirm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowCalendar: false, // カレンダー表示フラグ
      selectedDate: {
        start: null,
        end: null,
      },
      // カレンダー設定
      formats: {
        title: 'YYYY-MM-DD',
        input: ['YYYY-MM-DD'],
      },
      attrs: [
        {
          key: 'today',
          highlight: {
            fillMode: 'light',
          },
          dates: [new Date()],
        },
      ],
    }
  },
  computed: {
    // textフォーム 日付表示用
    inputText() {
      let inputText = ''
      let fromDate = this.selectedDate.start ? this.selectedDate.start : ''
      let toDate = this.selectedDate.end ? this.selectedDate.end : ''
      if (fromDate !== '' && toDate !== '') {
        inputText = `${this.formatDate(fromDate)} - ${this.formatDate(toDate)}`
      }
      return inputText
    },
    _from: {
      get() {
        return this.from
      },
      set(val) {
        this.$emit('update:from', val)
      },
    },
    _to: {
      get() {
        return this.to
      },
      set(val) {
        this.$emit('update:to', val)
      },
    },
  },
  watch: {
    // カレンダーパラメータを監視、変更をsearchパラメータに反映
    'selectedDate.start': function(val) {
      let dateText = ''
      if (val) dateText = this.formatDate(val)
      this._from = dateText
    },
    'selectedDate.end': function(val) {
      let dateText = ''
      if (val) dateText = this.formatDate(val)
      this._to = dateText
    },
    _from(val) {
      if (!val) {
        this.selectedDate.start = null
      }
    },
    _to(val) {
      if (!val) {
        this.selectedDate.end = null
      }
    },
  },
  created() {
    // 初期設定
    let fromDate = this._from
    let toDate = this._to
    if (fromDate && fromDate !== '') this.selectedDate.start = new Date(fromDate)
    if (toDate && toDate !== '') this.selectedDate.end = new Date(toDate)

    if (this.confirm) {
      const confirm7days = {
        highlight: {
          fillMode: 'light',
          class: 'is-_over_confirm_7days_background',
          contentClass: 'is-_over_confirm_7days_contents', // Class provided by TailwindCSS
        },
        dates: [
          {
            start: new Date().setDate(new Date().getDate() - 13),
            end: new Date().setDate(new Date().getDate() - 7),
          },
        ],
      }
      const confirm14days = {
        highlight: {
          fillMode: 'light',
          class: 'is-_over_confirm_14days_background',
          contentClass: 'is-_over_confirm_14days_contents', // Class provided by TailwindCSS
        },
        dates: [
          {
            start: null,
            end: new Date().setDate(new Date().getDate() - 14),
          },
        ],
      }
      this.attrs.push(confirm7days)
      this.attrs.push(confirm14days)
    }
  },
  methods: {
    // フォーム フォーカス処理
    onFocusInput() {
      this.isShowCalendar = true
    },
    // フォーム クリア処理
    onClearInput() {
      this.selectedDate.start = null
      this.selectedDate.end = null
    },
    // カレンダー非表示処理
    calendarHide() {
      this.isShowCalendar = false
    },
    // 日付フォーマット
    formatDate(date) {
      let format = 'yyyy-MM-dd'
      format = format.replace(/yyyy/g, date.getFullYear())
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2))
      format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2))
      format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2))
      format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2))
      format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3))
      return format
    },
  },
}
</script>

<style lang="scss">
.confirm-calendar {
  display: inline-block;
  &__mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(55, 55, 55, 0.6);
    height: 100%;
    z-index: 998;
  }
  &__wrap {
    position: relative;
    margin-right: 8px;
  }
  &__content {
    position: absolute;
    top: 32px;
    left: -32px;
    z-index: 999;
  }
  &__close {
    position: absolute;
    z-index: 1;
    top: -28px;
    right: -5px;
    cursor: pointer;
  }
  .is-_over_confirm_7days_background {
    background-color: #eedead;
  }

  .is-_over_confirm_14days_background {
    background-color: #eeadad;
  }
  .vc-popover-content-wrapper {
    z-index: 999999 !important;
  }
}
</style>
